<template>
  <div class="coupon-wrap">
    <div
      class="coupon clearfix"
      :class="{ used: coupon.is_can_get == 0 }"
      v-for="coupon in topCoupons"
      :key="coupon.id"
    >
      <span class="name">
        满{{ coupon.full_reduction / 100 }}减{{ coupon.discounted_price / 100 }}
      </span>
      <span class="get" v-if="coupon.is_can_get == 1" @click="getCoupon(coupon.id)"> 领取 </span>
      <span class="get" v-else>领取</span>
    </div>
    <div class="coupon-more" v-if="moreCoupons.length > 0" @click.stop="showCouponMore = true">
      <span>更多</span>
      <i class="el-icon-arrow-right"></i>
    </div>
    <CouponPanel
      v-if="showCouponMore"
      ref="couponPanel"
      :couponList="couponList"
      @getCoupon="getCoupon"
      @hidePanel="showCouponMore = false"
    ></CouponPanel>
  </div>
</template>
<script>
import CouponPanel from './CouponPanel.vue';
export default {
  name: 'Coupon',
  components: { CouponPanel },
  props: {
    couponList: {
      type: Array,
      default: () => {
        return [];
      },
    },
    defaultCount: {
      type: Number,
      default: 3,
    },
  },
  data() {
    return {
      showCouponMore: false,
    };
  },
  computed: {
    topCoupons() {
      return this.couponList.slice(0, this.defaultCount);
    },
    moreCoupons() {
      return this.couponList.slice(this.defaultCount);
    },
  },
  beforeDestroy() {
    this.$refs.couponPanel && this.$refs.couponPanel.$el.remove();
  },
  methods: {
    getCoupon(id) {
      this.$emit('getCoupon', id);
    },
  },
};
</script>
<style lang="scss" scoped>
.coupon-wrap {
  display: flex;
  align-items: center;
  position: absolute;
  width: 100%;
  left: 0;
  bottom: 83px;

  .coupon {
    margin: 0 10px 19px 0;
    font-size: 12px;
    line-height: 1;
    color: #ff2d28;

    .name,
    .get {
      border: 1px solid rgba(255, 45, 40, 1);
      border-radius: 4px;
      padding: 5px 7px;
      float: left;
      box-sizing: border-box;
    }

    .name {
      border-right-style: dashed;
    }

    .get {
      cursor: pointer;
      border-left: none;
    }

    &.used {
      color: #999;
      .get {
        cursor: default;
      }
      .get,
      .name {
        border-color: #999;
      }
    }
  }

  .coupon-more {
    height: 24px;
    line-height: 24px;
    font-size: 14px;
    color: #9a9a9a;
    cursor: pointer;
    margin-left: 4px;

    .el-icon-arrow-right {
      font-size: 16px;
    }
  }
}
</style>
